import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from "constants/index";

import React, { FC, ForwardedRef, useEffect, useState } from "react";

import AutocompleteHookForm from "components/Autocomplete/Autocomplete.hookform";
import { MultiAutocompleteHookForm } from "components/MultiAutocomplete";
import {
  TemplateTypeEntity,
  useGetManyBaseTemplateTypeControllerTemplateTypeEntity,
} from "generated";
import { useDebounce } from "hooks/useDebounce";

export interface SelectProps {
  name: string;
  label: string;
  require?: boolean;
  multi?: boolean;
  disabled?: boolean;
  onChange?: (value: any) => void;
}

type TemplateTypeSelectFormProps = SelectProps;

const TemplateTypeSelectForm: FC<TemplateTypeSelectFormProps> =
  React.forwardRef<HTMLSelectElement, TemplateTypeSelectFormProps>(
    (
      props: TemplateTypeSelectFormProps,
      ref: ForwardedRef<HTMLSelectElement>
    ) => {
      const { name, label, require, multi, disabled, onChange } = props;

      const [keyword, setKeyword] = useState("");
      const [searchTerm, setSearchTerm] = useState("");
      const [listOptions, setListOptions] =
        useState<{ label: string; value: unknown }[]>();

      const { data } = useGetManyBaseTemplateTypeControllerTemplateTypeEntity({
        s: JSON.stringify({
          ...(keyword
            ? {
                name: {
                  $contL: keyword,
                },
              }
            : {}),
          status: {
            $eq: "Active",
          },
        }),
        limit: DEFAULT_PAGE_SIZE,
        offset: DEFAULT_PAGE_INDEX,
      });

      // debounce
      const debouncedSearchTerm = useDebounce(searchTerm, 300);
      useEffect(() => {
        setKeyword(debouncedSearchTerm);
      }, [debouncedSearchTerm]);

      const handleSearchSelection = (value: string) => {
        setSearchTerm(value);
      };
      const handleResetData = (dataQuery: TemplateTypeEntity[]) => {
        let options: { label: string; value: unknown }[] = [];
        if (dataQuery && dataQuery.length > 0) {
          options = dataQuery.map((item) => ({
            value: item?.id,
            label: item?.name,
          }));
        }
        setListOptions(options);
      };
      useEffect(() => {
        handleResetData(data?.data?.data ?? []);
      }, [data]);

      return multi ? (
        <MultiAutocompleteHookForm
          name={name}
          label={label}
          placeholder="Select an option"
          options={listOptions ?? []}
          onInputChange={handleSearchSelection}
          required={require}
          disabled={disabled}
        />
      ) : (
        <AutocompleteHookForm
          name={name}
          label={label}
          placeholder="Select an option"
          options={listOptions ?? []}
          onInputChange={handleSearchSelection}
          required={require}
          disabled={disabled}
          onChange={onChange}
        />
      );
    }
  );
export default TemplateTypeSelectForm;
